import { Input } from "antd";
import { InputProps } from "antd/es/input/Input";


interface MaskedOptions extends InputProps {
	mask: string;
}



/**
 * Allows creating a masked input.
 * 
 * @todo Implement mask
 */
export default function MaskedInput({
	mask,
	...props
}: MaskedOptions) {
	return (<>
		<Input {...props} autoComplete="off" />
	</>);
}
